// @flow

"use strict";

/**
 * URL関連ユーティリティクラス
 */
export default class URLUtil {

  /**
   * URLエンコード
   * @return {string}
   */
  static fixedEncodeURIComponent(urlString: string): string {
    return encodeURIComponent(urlString).replace(/[!'()*]/g, function (c: string): string {
      return '%' + c.charCodeAt(0).toString(16);
    });
  }

  /**
   * リファラ取得
   * speee akamaiの場合はurl=がエンコードされているurl%22%3A%22から&がエンコードされた%22%2C%22までを取得しデコードしたものをリファラとする
   * @return {string}
   */
  static getReferer(refer: string, path: string): string {
    // refererにpathが含まれていたらurl=xxx&の部分を抜き出す
    if (refer.match(path)) {
      const matchedArray: Array<string> = refer.match(new RegExp('url%22%3A%22(.+?)%22%2C%22'));
      if(matchedArray && matchedArray.length > 1){
        return decodeURIComponent(matchedArray[1]);
      }
    }

    return URLUtil.fixedEncodeURIComponent(refer);
  }

  /**
   * 無限スクロール時の記事URLを取得する。
   * elementから親のDomを遡っていきsearchDomFunctionの条件に一致するElementに達した場合getAttributeFunctionがそのElementから指定した属性の値を取得する
   * この関数を呼び出すときは必ず呼び出し元でエラーハンドリングしてください
   * @param element
   * @param searchElementFunction
   * @param getAttributeFunction
   * @returns {string}
   */
  static getInfiniteScrollArticleURL(
      element: HTMLElement,
      searchElementFunction: (HTMLElement)=> boolean,
      getAttributeFunction: (HTMLElement) => string): string{
    let parentElement = element.parentNode;
    while(parentElement){
      if (searchElementFunction(parentElement)){
        return getAttributeFunction(parentElement);
      }

      parentElement = parentElement.parentNode;
    }

    // 一致した条件のelementが存在しなければエラー
    throw new Error("Not Found InfiniteScrollArticleURL");
  }
}


// WEBPACK FOOTER //
// ./src/js/util/url-util.js